export function createToggle(key, fallback = true, storage = globalThis.localStorage) {
  const read = () => {
    try {
      const stored = storage?.getItem(key);
      return stored === null || stored === undefined ? fallback : stored === "1";
    } catch {
      return fallback;
    }
  };
  let value = read();
  const write = () => {
    try {
      storage?.setItem(key, value ? "1" : "0");
    } catch {
      return false;
    }
    return true;
  };
  return {
    get enabled() {
      return value;
    },
    set(next) {
      value = Boolean(next);
      write();
      return value;
    },
    toggle() {
      return this.set(!value);
    }
  };
}
